const data =[
  {
    name: "Clearer reporting pathways",
    number: "01",
    detail: "Staff understand how to record, report and escalate concerns appropriately.",
  },
  {
    name: "More confident staff",
    number: "02",
    detail: "Training is practical, scenario based and rooted in real school life.",
  },
  {
    name: "Stronger safeguarding culture",
    number: "03",
    detail: "Safeguarding becomes more visible in routines, conversations and adult practice.",
  },
  {
    name: "Improved leadership clarity",
    number: "04",
    detail: "Leaders are supported to identify priorities, address gaps and plan next steps.",

  },
  {
    name: "Practical tools and recommendations",
    number: "05",
    detail: "Schools receive focused summaries, roadmaps or tools depending on the selected engagement.",
  },
];
export default data;